export default{
    getMessages(state){
        return state.messages;
    },
    getErros(state){
        return state.errors;
    }
}